module.exports = __webpack_public_path__ + "static/media/store-marker.8cd2e1f4.svg";